import { render } from "./putTranslateItems.vue?vue&type=template&id=5da75f9f&scoped=true"
import script from "./putTranslateItems.vue?vue&type=script&lang=js"
export * from "./putTranslateItems.vue?vue&type=script&lang=js"

import "./putTranslateItems.vue?vue&type=style&index=0&id=5da75f9f&scoped=true&lang=css"

import exportComponent from "/home/tyamada/ckan-ext-dev/yamanashi-dataplatform-admin-system-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da75f9f"]])

export default __exports__